import React from 'react'
import { useState, useEffect } from 'react'
import { BackButton } from '@/components/layout/NavBar'
import { Services } from '@/services/services'
import { useParams } from 'react-router-dom'

import { CurrentSession } from '@/services/repository/session'
import { MainPageLayout } from '@/components/layout/MainLayout'
import { Translates } from '@/services/repository/i18n'
import { HitMapComponent } from '@/components/Map/HitMap'

import './MyHitMap.css'

export const CommunalMyHitsMap = ({ services, session }: { services: Services, session: CurrentSession }) => {
  const mid = useParams().mid
  const [translates, setTranslates] = useState<Translates>()

  useEffect(() => {
    if (session) {
      setTranslates(session.translates)
      return
    }
    services.i18n.get('main').then(setTranslates)
  }, [session])

  if (translates === undefined) {
    return <div className='spinner'></div>
  }

  return <MainPageLayout pageName='my-hitmap' services={services} translates={translates} session={session}
    navbarLeft={<BackButton services={services} translates={session.translates} />}>
    <HitMapComponent fetchUrl='/api/communal/my/hits/all' services={services} session={session} />
  </MainPageLayout>
}
